const PARAMETER_MAP = Object.freeze({
  PROLIFIC_PID: "prolificPid",
  STUDY_ID: "prolificStudyId",
  SESSION_ID: "prolificSessionId",
});

export class ProlificEntryParameterError extends Error {
  constructor() {
    super("Invalid Prolific entry parameters");
    this.name = "ProlificEntryParameterError";
  }
}

export function readProlificEntryFromUrl(href = window.location.href) {
  const url = new URL(href);
  const entries = Object.entries(PARAMETER_MAP).map(([queryName, payloadName]) => ({
    queryName,
    payloadName,
    values: url.searchParams.getAll(queryName),
  }));
  const present = entries.filter((entry) => entry.values.length > 0);
  if (present.length === 0) return { kind: "direct" };
  if (present.length !== entries.length || entries.some((entry) => entry.values.length !== 1)) {
    throw new ProlificEntryParameterError();
  }
  return {
    kind: "prolific",
    payload: Object.fromEntries(entries.map((entry) => [entry.payloadName, entry.values[0]])),
  };
}

export function removeProlificParametersFromAddressBar({
  href = window.location.href,
  history = window.history,
} = {}) {
  const url = new URL(href);
  Object.keys(PARAMETER_MAP).forEach((name) => url.searchParams.delete(name));
  history.replaceState(history.state, "", `${url.pathname}${url.search}${url.hash}`);
}
